module.exports = __webpack_public_path__ + "img/repnode-logo.d2555e6e.png";